import { Module } from 'vuex';
import { RootState } from '../store';
import { actions } from '../actions/documents.actions';
import { mutations } from '../mutations/documents.mutations';
import { ITag } from '@/types/Tag';

export const namespace = 'documents';

//TODO: We should add documents and tags here in the future
export interface DocumentsState {
  isLoadingTags: boolean;
  tags: ITag[];
}

export const state: DocumentsState = {
  isLoadingTags: false,
  tags: [],
};

const namespaced: boolean = true;

export const documents: Module<DocumentsState, RootState> = {
  actions,
  mutations,
  namespaced,
  state,
};
